import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// graphql
import { SYSTEM_PROCESSES_LIST_QUERY } from 'graphql/systemProcesses/queries'
// types
import { TRefetch } from 'types/refetch'
import { NGetSystemProcesses } from 'types/system-process/helpers'
import { ISystemProcess, ISystemProcessesResponse } from 'types/graphql'
// utils
import get from 'lodash/get'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = {
  systemProcesses: ISystemProcessesResponse
}

interface IContext {
  data: ISystemProcess[]
  refetch: TRefetch<QueryResponse, NGetSystemProcesses.IVariables>
  isLoading: boolean
  totalCount: number
  isRefetching: boolean
}

export const SystemProcessesPageContext = React.createContext<IContext>({} as any)

const SystemProcessesPageAPI: React.FC<Props> = ({ children }) => {
  const { search, filter, page, perPage } = React.useContext(TableManagementContext)

  const { data, networkStatus, refetch } = useQuery<QueryResponse>(SYSTEM_PROCESSES_LIST_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        ...filter,
        search
      },
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    }
  })

  const systemProcesses = get(data, 'systemProcesses.data', [])
  const totalCount = get(data, 'systemProcesses.pagination.totalCount')

  const value = {
    refetch,
    totalCount,
    data: systemProcesses,
    isLoading: networkStatus === 1,
    isRefetching: networkStatus === 2
  }

  return <SystemProcessesPageContext.Provider value={value}>{children}</SystemProcessesPageContext.Provider>
}

export default SystemProcessesPageAPI
